import Cookies from "js-cookie"

import { IS_PRODUCTION_OR_STAGING } from "./environment"

declare global {
  interface Window {
    // https://my.onetrust.com/s/article/UUID-66bcaaf1-c7ca-5f32-6760-c75a1337c226
    OnetrustActiveGroups?: string
  }
}

type ConsentId = (typeof CONSENT)[keyof typeof CONSENT]

const CONSENT_COOKIE_NAME = "OptanonConsent"
const CONSENT_ID_KEY = "groups"
const ONETRUST = document.body.getAttribute("data-onetrust") === "true"

// https://app-uk.onetrust.com/cookies/categories
const CONSENT = Object.freeze({
  NECESSARY: "C0001",
  PERFORMANCE: "C0002",
  FUNCTIONALITY: "C0003",
  TARGETING: "C0004"
} as const)

const isConsentGranted = (consentId: ConsentId): boolean => {
  if (consentId === CONSENT.NECESSARY || !ONETRUST) {
    return true
  }

  const { OnetrustActiveGroups } = window

  // Check window object first, if not available check cookie as fallback
  if (OnetrustActiveGroups) {
    // Format is "C0001,C0002"
    return OnetrustActiveGroups.split(",").includes(consentId)
  } else {
    const consentCookie = Cookies.get(CONSENT_COOKIE_NAME) || ""
    const parts = new URLSearchParams(consentCookie)
    const groups = parts.get(CONSENT_ID_KEY) || ""

    // Format is "C0001:1,C0002:0"
    return groups.split(",").includes(`${consentId}:1`)
  }
}

const cookiesWithAttributes = Object.create(
  Cookies.withAttributes({
    samesite: "lax",
    secure: IS_PRODUCTION_OR_STAGING
  })
) as Cookies.CookiesStatic

const cookiesWithConsent = Object.assign(cookiesWithAttributes, {
  setIfConsent: (
    consentId: ConsentId,
    name: string,
    value: string,
    options?: Cookies.CookieAttributes
  ): string | undefined => {
    if (isConsentGranted(consentId)) {
      return cookiesWithAttributes.set(name, value, options)
    }
  }
})

export { cookiesWithConsent as default, CONSENT }
